<script>
  import { t } from 'precompile-intl-runtime';
  import ui from '/stores/UI';
  import SaveButton from 'components/SaveButton/SaveButton';
  import errorIcon from 'icons/error.svg';

  function resetEverything() {
    window.drop();
    location.reload();
  }
</script>

<div class="container">
  <div class="reload-dialog">
    <div class="icon">
      {@html errorIcon}
    </div>
    <h1>{$t('errorDialog.header')}</h1>
    <p>{$t('errorDialog.message')}</p>
    <div class="details-buttons">
      <details>
        <summary>{$t('errorDialog.detailsHeader')}</summary>
        <p>{$ui.lastException.message}</p>
        <pre>{$ui.lastException.stack}</pre>
      </details>
      <SaveButton />
    </div>

    <button class="button" on:click={resetEverything}
      >{$t('errorDialog.resetButton')}</button
    >
  </div>
</div>

<style>
  .container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    z-index: 10000;

    background-color: rgba(0, 0, 0, 0.8);

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .reload-dialog {
    background-color: var(--color-1);
    color: var(--color-2);
    padding: 1rem 4rem;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 40rem;
  }

  p {
    font-size: 16px;
  }

  button {
    padding: 8px;
  }

  details {
    border: 1px solid black;
    padding: 1rem;
    background-color: white;
  }

  button {
    border-radius: 4px;
    border: 1px black;
    color: black;
    background-color: #ce3737;
    margin: 10px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    width: 10rem;
  }
  .details-buttons {
    display: flex;
    align-items: center;
  }
</style>
